import React from 'react'
import PropTypes from 'prop-types'
import { filesize } from 'filesize'
import { getYoutubeThumbnailUrl } from 'domain/adPreview/format'
import { WarningTriangleIcon } from 'images'

export default function SingleMediaPreview({ file }) {
  if (!file) return null

  const isYoutube = Boolean(file.youtube_video_id)
  const isVideo = file.type?.startsWith('video')
  const warnings = isYoutube ? file.warnings ?? [] : []

  return (
    <div className="original-media-preview-modal">
      {warnings.length > 0 && (
        <div className="original-media-preview-modal__warnings">
          {warnings.map((warning, index) => (
            <div key={index} className="original-media-preview-modal__warning">
              <WarningTriangleIcon width={14} height={14} />
              <span>{warning}</span>
            </div>
          ))}
        </div>
      )}

      <div className="image">
        {isYoutube ? (
          <img
            src={getYoutubeThumbnailUrl(file.youtube_video_id)}
            alt={file.title || file.filename}
          />
        ) : isVideo ? (
          <video controls src={file.url} title={file.name || file.filename} />
        ) : (
          <img src={file.preview || file.url} alt={file.name || file.filename} />
        )}
      </div>

      <div className="header">
        <p>{isYoutube ? (file.title || file.filename) : (file.filename ?? file.name)}</p>
        {!isYoutube && <p>{filesize(file.size || 0)}</p>}
      </div>
    </div>
  )
}

SingleMediaPreview.propTypes = {
  file: PropTypes.object.isRequired,
}
